<template>
  <div>
    <trial-to-paid v-if='$context.is.trial2paid' :is-show-subtitle="isShowSubtitle"/>
    <success :show-promotes='false' v-else-if='isFreeTrial'>
      <thanks :email='email' :title='trialTitle'>
        <subtitle :sub-title="trialSubtitle" v-if="trialSubtitle" />
        <zm-button
          v-if='isAutoAssigned'
          data-testid="checkout-button-91"
          target='_blank'
          size='large'
          round
          type='primary'
          :href='webinarLink'
          :data-url='webinarLink'
          @click='goFreeTrialTracking'
          class='text-capitalize'>
          {{ $t('billing.success.get_started') }}
          <!-- {{ $t('billing.trial.start_free_trial_btn', [buyTrialPlanName]) }} -->
        </zm-button>
        <user-management-cta :cta-name="$t('billing.success.confirmation.user_cta')" v-if='!isAutoAssigned' :utm-content='UTM_CONTENT_CODE.assignLicenseToUsers' />
        <!-- No need to cta to /billing but possible needed in future. -->
        <!-- <view-account type='round' v-if='$context.is.add2trial && isAutoAssigned' /> -->
      </thanks>
    </success>
    <CommonAddon v-else>
      <template #viewAccountOnly v-if="shouldGoWebinar">
        <zm-button size='large' type="primary" round @click="goWebinar">{{ $t('billing.trial.webinar.back_to_webinar') }}</zm-button>
      </template>
    </CommonAddon>
  </div>
</template>

<script>
import CommonAddon from '@/views/succezz/components/common-addon.vue';
import Success from '@/views/succezz/facade.vue';
import Thanks from '@/views/succezz/thanks-template/index.vue';
import Subtitle from '@/views/succezz/thanks-template/subtitle.vue';
import common from '@/views/succezz/mixin/common';
// import ViewAccount from '@/views/succezz/thanks-template/view-account.vue';
import { mapGetters } from 'vuex';
import UserManagementCta from '@/views/succezz/thanks-template/user-management-cta.vue';
import TrialToPaid from '@/views/succezz/components/trial-to-paid.vue';
import { UTM_CONTENT_CODE } from '@/views/succezz/utils/email-ctas-tracking';

export const WEBINAR500_SCHEDULE_LINK = "/webinar/whatis";

export default {
  mixins: [common],
  components: {
    TrialToPaid,
    UserManagementCta,
    // ViewAccount,
    Subtitle,
    Thanks, Success,
    CommonAddon,
  },
  data() {
    return {
      UTM_CONTENT_CODE,
      webinarLink: WEBINAR500_SCHEDULE_LINK,
      shouldGoWebinar: !!window.$query?.softWbnSub,
    };
  },
  computed: {
    ...mapGetters(['successConfig']),
    isFreeTrial() {
      return this.$context.is.add2trial;
    },
    buyTrialPlanName() {
      return this.$t('billing.webinar.title') || '';
    },
    trialTitle() {
      // For webinar free trial, always using the same title whatever auto assign or not
      return this.$t('billing.trial.trial_auto_assign_title', [this.buyTrialPlanName]);
    },
    isAutoAssigned() {
      return !!this.successConfig.assigned2currentUser;
    },
    trialSubtitle() {
      if (!this.isAutoAssigned) {
        return this.$t('billing.webinar.trial.assign_users');
      }
      // return this.$t('billing.trial.trial_auto_assign_subtitle', [this.buyTrialPlanName]);
      return '';
    },
    isShowSubtitle() {
      // No subtitle for webinar500 ft
      return false;
    }
  },
  methods: {
    goWebinar() {
      if (window.opener) {
        window.opener?.postMessage(
          {
            type: 'soft_webinar_sub', // keep sync with Webinar Team
            success: true,
          },
          window.location.origin
        );
        setTimeout(() => { window.close(); }, 0);
      }
    },
    goFreeTrialTracking() {
      this.$tracking.buyInteraction('purchase confirmation', 'set up zoom webinar');
    },
  },
};
</script>
